import { createSelector } from 'reselect'

import { _userId } from './User'

export const _roomName = state => state.room.roomName
export const _roomUserId = state => state.room.userId
export const _roomState = state => state.room.roomState
export const _roomType = state => state.room.roomType
export const _dominantSpeaker = state => state.room.dominantSpeaker
export const _IsSpeaking = state => state.room.isSpeaking
export const _IsMaster = state => state.room.isMaster
export const _isLoading = state => state.room.isLoading
export const _isRecording = state => state.room.isRecording
export const _isInteractionMode = state => state.room.isInteractionMode
export const _twilioToken = state => state.room.twilioToken

export const _participants = state => state.room.participants

export const _classTitle = state => state.room.classTitle

export const _studentsCount = state => state.room.studentsCount

export const getParticipantInfo = createSelector(
    _participants,
    (_, id) => id,
    (participants, id) =>
        participants.find(participant => participant.id === id)
)

export const _hasRemoteParticipants = createSelector(
    _participants,
    participants => !!participants.length
)

export const _latestConnectedParticipant = state =>
    state.room.latestConnectedParticipant

export const _latestDisconnectedParticipant = state =>
    state.room.latestDisconnectedParticipant

export const _isNetworkBandwidthSaverMode = state =>
    state.room.isNetworkBandwidthSaverMode

export const _remoteParticipants = createSelector(
    _userId,
    _participants,
    (_, property) => property,
    (localUserId, participants, property) => {
        const remoteParticipants = participants.filter(
            participant => participant.id !== localUserId
        )
        if (!property) return remoteParticipants

        return remoteParticipants.map(participant => participant[property])
    }
)
